import { dailyHots } from "@/mocks/guaData";
import SectionHead from "./SectionHead";

const tagTone: Record<string, string> = {
  刚刚爆: "bg-primary-100 text-primary-700",
  实锤反转: "bg-accent-100 text-accent-800",
  同框破冰: "bg-secondary-200 text-secondary-900",
};

export default function DailyHot() {
  return (
    <section id="today" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHead kicker="Today · 今日新瓜" title="今天有什么瓜，先看这波" more="#hot-rank" />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {dailyHots.map((item, i) => (
            <article
              key={item.title}
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200/70 bg-background-100/60 p-5 transition hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="mb-3 flex items-center gap-2">
                <span className="font-heading text-lg font-black text-background-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${tagTone[item.tag] ?? "bg-secondary-100 text-secondary-800"}`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.brief}</p>
              <div className="mt-4 flex items-center gap-4 border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-time-line" />{item.time}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line" />{item.reads}</span>
                <span className="inline-flex items-center gap-1 text-primary-600">
                  <i className="ri-chat-3-line" />{item.comments.toLocaleString()}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}